"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.COL_BUTTON, (table)=>{
        table.string('fk_integration_id', 20);
        table.string('model', 255);
        table.text('output_column_ids');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.COL_BUTTON, (table)=>{
        table.dropColumn('fk_integration_id');
        table.dropColumn('model');
        table.dropColumn('output_column_ids');
    });
};
